import { mdiPlus } from "@mdi/js";
import Icon from "@mdi/react";
import { useEffect, useRef, useState } from "react";
import "../../../../ui/new_components/common/autocomplete/index.css";
interface AutoCompleteFieldProps<T> {
  onSelect?: (data: { label: any; value: T }) => void;
  suggestions?: { label: any; value: T }[];
  onChange?: (data: string) => void;
  value?: string;
  placeholder?: string;
  loading: boolean;
  disabled?: boolean;
  onAddNew?: () => void;
  defaultShow?: boolean;
}

const ItemDescriptionAutoCompleteField = <T extends { id?: string }>({
  placeholder,
  value,
  onChange,
  suggestions,
  onSelect,
  loading,
  disabled = false,
  onAddNew,
  defaultShow = false,
}: AutoCompleteFieldProps<T>): JSX.Element => {
  // const AutoCompleteField: FunctionComponent<AutoCompleteFieldProps> = ({
  //   placeholder,
  //   value,
  //   onChange,
  //   suggestions,
  //   onSelect,
  //   loading,
  //   disabled = false,
  //   onAddNew,
  // }) => {
  const [show, setShow] = useState(
    defaultShow === undefined ? true : defaultShow
  );
  // const [mySuggestion, setMySuggestion] = useState<
  //   { label: any; value: T }[] | undefined
  // >();
  const ref = useRef<any>(null);
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target)) {
        setShow(false);
      } else {
        setShow(true);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
  useEffect(() => {
    if (suggestions && suggestions.length) {
      setShow(true);
    }
  }, [suggestions]);
  return (
    <div ref={ref} className="relative w-full  ">
      <textarea
        autoFocus
        disabled={disabled}
        autoComplete="off"
        id=""
        name="autocomplete"
        value={value}
        onChange={(e) => {
          if (onChange) onChange(e.target.value);
        }}
        className="p-1 rounded h-24 focus:outline-none w-full border"
        placeholder={placeholder ?? "Search"}
      />
      {show && suggestions && (
        <div className="flex flex-col    border rounded  absolute bg-white z-40 w-full  ">
          <div className="flex flex-col        w-full max-h-72 overflow-y-auto overflow-x-hidden divide-y">
            {suggestions.map((suggestion, index) => {
              return (
                <div
                  id={`suggestion_${index}`}
                  className="  text-xs hover:bg-gray-100   px-2 py-1 cursor-pointer"
                  key={index}
                  onClick={() => {
                    if (onSelect) onSelect(suggestion);
                  }}
                >
                  {suggestion.label}
                </div>
              );
            })}
          </div>
          {loading && (
            <div className="flex  text-xs hover:bg-gray-100   px-2 py-1 cursor-pointer">
              <p className="text-gray-300"> Loading ...</p>
            </div>
          )}

          {onAddNew && (
            <div
              id="add_new_btn"
              onClick={onAddNew}
              className="flex  justify-between text-xs hover:bg-gray-100   p-2  cursor-pointer  "
            >
              <p className="text-red-300"> Not Found ?</p>
              <div className="flex items-center gap-1 text-myPrimaryColor">
                <Icon path={mdiPlus} className="w-5 h-5"></Icon>
                <p>Add new</p>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ItemDescriptionAutoCompleteField;
